<p-panel header="{{ 'fs.res.common.classifications' | hisUi }}">

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<res-subject-area-plam
		*ngIf="!subjectAreasDynamicFieldConfig"
		[selectedSubjectAreas]="subjectAreas"
		(selectedSubjectAreasChange)="onSubjectAreasChange($event)"
		[subjectAreaDdKey]="subjectAreaDdKey"
		[editMode]="editMode">
	</res-subject-area-plam>
    <div *ngIf="subjectAreasDynamicFieldConfig">
        <his-dynamicfield [form]="changeRequesForm" [valueGroup]="changeRequestValueGroup" [dynamicFieldConfig]="subjectAreasDynamicFieldConfig"></his-dynamicfield>
        <br><br>
    </div>

    <!-- #anchor dynamic field container -->
    <ng-template #dynamicFieldContainer></ng-template>

    <res-research-area-kdsf-plam
    	*ngIf="!researchAreasKdsfDynamicFieldConfig"
        [selectedResearchAreasKdsf]="researchAreasKdsf"
        (selectedResearchAreasKdsfChange)="onResearchAreasKdsfChange($event)"
        [researchAreaKdsfDdKey]="researchAreaKdsfDdKey"
        [editMode]="editMode">
    </res-research-area-kdsf-plam>
    <div *ngIf="researchAreasKdsfDynamicFieldConfig">
        <his-dynamicfield [form]="changeRequesForm" [valueGroup]="changeRequestValueGroup" [dynamicFieldConfig]="researchAreasKdsfDynamicFieldConfig"></his-dynamicfield>
        <br><br>
    </div>

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

    <res-research-area-plam
    	*ngIf="!researchAreasDynamicFieldConfig"
        [selectedResearchAreas]="researchAreas"
        (selectedResearchAreasChange)="onResearchAreasChange($event)"
        [researchAreaDdKey]="researchAreaDdKey"
        [editMode]="editMode">
    </res-research-area-plam>
    <div *ngIf="researchAreasDynamicFieldConfig">
        <his-dynamicfield [form]="changeRequesForm" [valueGroup]="changeRequestValueGroup" [dynamicFieldConfig]="researchAreasDynamicFieldConfig"></his-dynamicfield>
    </div>

    <!-- #anchor dynamic field container -->
    <ng-template #dynamicFieldContainer></ng-template>

</p-panel>
